export default {
  meta: {
    siteName: 'Soul Training',
    tagline: 'Online fitness i prehrana coaching',
  },
  nav: {
    home: 'Početna',
    about: 'O treneru',
    online: 'Online trening',
    gym: 'Trening uživo',
    pricing: 'Cjenik',
    results: 'Transformacije',
    faq: 'FAQ',
    contact: 'Kontakt',
    login: 'Prijava',
    cta: 'Besplatna procjena',
  },
  common: {
    loading: 'Učitavanje…',
    retry: 'Pokušaj ponovno',
    cancel: 'Odustani',
    save: 'Spremi',
    back: 'Nazad',
    next: 'Dalje',
    close: 'Zatvori',
    required: 'Obavezno polje',
  },
  empty: {
    noWorkoutToday: 'Danas je odmor. Oporavak je dio napretka.',
    noMeasurements: 'Dodaj prvu mjeru i napredak postaje vidljiv.',
    noMeals: 'Dnevnik prehrane je prazan. Dodaj prvi obrok.',
    noPhotos: 'Slikaj prvu fotografiju napretka i pokreni svoju vizualnu priču.',
    noMessages: 'Još nema poruka. Javi se treneru kad god zatreba.',
    noClients: 'Još nemaš klijenata. Kad netko kupi paket, pojavit će se ovdje.',
    noPrograms: 'Nema programa. Napravi prvi u graditelju programa.',
  },
  error: {
    generic: 'Nešto je pošlo po zlu.',
    genericHelp: 'Pokušaj ponovno. Ako se ponovi, javi nam se.',
    network: 'Nema veze s internetom.',
    networkHelp: 'Tvoji podaci su spremljeni na uređaju i poslat će se čim se vratiš online.',
    sessionExpired: 'Prijava je istekla.',
    sessionExpiredHelp: 'Prijavi se ponovno da nastaviš.',
    paymentFailed: 'Plaćanje nije prošlo.',
    paymentFailedHelp: 'Provjeri podatke o kartici ili pokušaj s drugom.',
    // 402 — sadržaj iza paketa. Nije isto što i neuspjelo plaćanje.
    contentLocked: 'Ovaj sadržaj je dio plaćenog programa.',
    contentLockedHelp: 'Odaberi paket i program se otključava do kraja.',
    subscriptionInactive: 'Pretplata nije aktivna.',
    subscriptionInactiveHelp: 'Odaberi paket da otključaš svoj program.',
    uploadFailed: 'Slanje datoteke nije uspjelo.',
    uploadFailedHelp: 'Fotografija je sačuvana na uređaju. Pokušaj ponovno.',
    syncFailed: 'Sinkronizacija treninga nije uspjela.',
    syncFailedHelp: '{count} zapisa čeka slanje. Poslat će se automatski.',
    forbidden: 'Nemaš pristup ovom sadržaju.',
    notFound: 'Stranica ne postoji.',
  },
  auth: {
    login: 'Prijava',
    register: 'Registracija',
    email: 'Email',
    password: 'Lozinka',
    passwordConfirm: 'Potvrdi lozinku',
    firstName: 'Ime',
    lastName: 'Prezime',
    forgot: 'Zaboravljena lozinka?',
    submitLogin: 'Prijavi se',
    submitRegister: 'Kreiraj račun',
    verifySent: 'Poslali smo ti email za potvrdu adrese.',
    invalidCredentials: 'Pogrešan email ili lozinka.',
  },
  pricing: {
    title: 'Odaberi svoj program',
    popular: 'Najpopularniji',
    buy: 'Kupi pristup',
    perMonth: 'mjesečno',
    perQuarter: 'kvartalno',
    oneTime: 'jednokratno',
    months: '{n} mjeseca',
    vatNote: 'Cijene su konačne.',
  },
  checkout: {
    processing: 'Obrađujemo uplatu…',
    processingHelp: 'Ovo traje nekoliko sekundi. Ne zatvaraj stranicu.',
    success: 'Uplata je potvrđena.',
    successHelp: 'Tvoj program je spreman. Prijavi se u portal ili preuzmi aplikaciju.',
  },
  portal: {
    dashboard: 'Početna',
    training: 'Trening',
    nutrition: 'Prehrana',
    progress: 'Napredak',
    messages: 'Poruke',
    profile: 'Profil',
    subscription: 'Pretplata',
    todayWorkout: 'Trening dana',
    startWorkout: 'Započni trening',
    workoutComplete: 'Trening završen',
  },
} as const;
